import axios from "axios";
import React, { useEffect, useState } from "react";
import "./addfaq.scss";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/loading/Loading";

function Addfaq() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [title, setTitle] = useState();
  const [add, setAdd] = useState({
    category: "",
    question: "",
    answer: "",
  });

  const addFaq = async () => {
    if (add.category !== "" && add.question !== "" && add.answer !== "") {
      setLoading(true);
      await axios.post("https://mobile.amospa.com/faqs", add);
      setLoading(false);
      setTitle("Succes Add FAQ");
      setModalShow(true);
    } else {
      setTitle("fill in all forms");
      setModalShow(true);
    }
  };

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
    navigate("/homepage/setting/faq/");
  };

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="wrapper-add-faq">
                <div className="header-add-faq">
                  <h5 className="m-0">Create new Faq</h5>
                </div>
                <div className="form-add-faq">
                  <div className="wrapper-data">
                    <label>
                      Category <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="category"
                      onChange={(e) =>
                        setAdd({ ...add, category: e.target.value })
                      }
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>
                      Question <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="question"
                      onChange={(e) =>
                        setAdd({ ...add, question: e.target.value })
                      }
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>
                      Answer <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="answer"
                      onChange={(e) =>
                        setAdd({ ...add, answer: e.target.value })
                      }
                    />
                  </div>
                  <button className="text-white" onClick={() => addFaq()}>
                    Create new Faq
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={title}
        nextButton={
          title !== "Isi Semua Form" ? handleNext : () => setModalShow(false)
        }
      />
    </div>
  );
}

export default Addfaq;
